export default __webpack_public_path__ + "static/La Playa Vol. 3 Homepage Banner Desktop - W4-923349f0f140d1a2c2e4a14b5f1c6ff3.webp";